import { BULK_UPLOAD_BOM, CREATE_BOM_DETAILS, DELETE_BILL_OF_MATERIALS, DELETE_BOM_DETAILS, DUPLICATE_BOM, EDIT_BILL_OF_MATERIALS, GET_ALL_BOM_DETAILS, GET_BOM_DETAILS, GET_BOM_DETAILS_BY_ID, GET_ITEMS_BOM_DETAILS, UPDATE_BOM_DETAILS } from "../../types/API/bomDetails";

export function getBOMDetails(payload: any) {
  return {
    type: GET_BOM_DETAILS,
    payload: payload,
  };
}

export function getBOMById(payload: any) {
  return {
    type: GET_BOM_DETAILS_BY_ID,
    payload: payload,
  };
}

export function getAllBOMDetails(payload: any) {
  return {
    type: GET_ALL_BOM_DETAILS,
    payload: payload,
  };
}

export function createBOMDetails(payload: any) {
  return {
    type: CREATE_BOM_DETAILS,
    payload: payload,
  };
}
export function updateBOMDetails(payload: any) {
  return {
    type: UPDATE_BOM_DETAILS,
    payload: payload,
  };
}

export function deleteBOMDetails(payload: any) {
  return {
    type: DELETE_BOM_DETAILS,
    payload: payload,
  };
}

export function deleteBillOfMaterials(payload: any) {
  return {
    type: DELETE_BILL_OF_MATERIALS,
    payload: payload,
  };
}

export function editBillOfMaterials(payload: any) {
  return {
    type: EDIT_BILL_OF_MATERIALS,
    payload: payload,
  };
}

export function getItemsBOMDetails(payload: any) {
  return {
    type: GET_ITEMS_BOM_DETAILS,
    payload: payload,
  };
}

export function duplicateBom(payload: any) {
  return {
    type: DUPLICATE_BOM,
    payload: payload,
  };
}

export function bulkUploadBom(payload: any) {
  return {
    type: BULK_UPLOAD_BOM,
    payload: payload,
  };
}
